import { BaseClass } from './base';

export class User extends BaseClass {
    id: number;
    username: string;
    password: string;
    token?: string;
    message: string;
    name: String;
    employee_id : any;
    position: String;
    department: String;
    payroll_acct_no: any;
    role_id: number;
    role_name: String;
    is_final_approver: number;
    _errors = {
        email: '',
        password: ''
    };
    constructor(data: any = [] ) {
        super();
        this.message = data.message || '';
        this.name = data.name || '';
        this.token = data.token || '';
        this.employee_id = data.employee_id || '';
        this.position =  data.position || '';
        this.department = data.department || '';
        this.payroll_acct_no = data.payroll_acct_no || '';
        this.role_id = data.role_id || '';
        this.role_name = data.role_name || '';
        this.is_final_approver = data.is_final_approver || '';
        this.id = data.id || '';
    }

    setErrors(err) {
        if (err.errors.email != undefined) {
            this._errors.email = err.errors.email[0];
        }
        if (err.errors.password != undefined) {
            this._errors.password = err.errors.password[0];
        }
    }

    getRole(){
        let user = JSON.parse(localStorage.getItem('cashUser'));
        return (user.role_id === 1 || user.role_id === 100 || user.role_id === 101 || user.role_id === 200)? true : false || false;
    }
}